import React from 'react';
import withIcon from '../utilities/withIcon';

const IconClock = () => {
  return (
    <g>
      <path d="M8 0a8 8 0 1 1 0 16A8 8 0 0 1 8 0zm0 1.5a6.5 6.5 0 1 0 0 13 6.5 6.5 0 0 0 0-13zm0 1.505a.75.75 0 0 1 .743.648l.007.102v3.791l2.6 1.359a.75.75 0 0 1 .36.918l-.042.094a.75.75 0 0 1-.919.358l-.093-.041-3.003-1.57a.75.75 0 0 1-.396-.56L7.25 8V3.755a.75.75 0 0 1 .75-.75z" />
    </g>
  );
};

export default withIcon(IconClock);
